import { useId } from 'react'
import { useTranslation } from 'react-i18next'

import { isCompleteOtp, normalizeOtp } from '../lib/countdown'

/**
 * OTP alani: ALTI KUTU DEGIL, tek input.
 *
 * Alti tek-karakter kutusu guzel gorunuyor ama uc somut problem uretiyor:
 *
 *  1. **`autocomplete="one-time-code"` bozuluyor.** Tek input'ta iOS ve
 *     Android, Mail/SMS'ten gelen kodu TEK DOKUNUSLA dolduruyor. Alti kutuya
 *     bunu yapamiyorlar; kullanici kodu elle yaziyor.
 *  2. **Ekran okuyucu alti kez "edit text, blank" diyor.** Tek alanin tek bir
 *     etiketi var.
 *  3. **Ok/backspace/paste yonetimi asla tam dogru olmuyor** - her uygulamada
 *     biraz farkli ve biraz bozuk.
 *
 * Segmentli GORUNUM `letter-spacing` + monospace ile CSS'te saglaniyor, yani
 * gorsel kazanc kaybedilmiyor.
 *
 * 6. hanede otomatik gonderim var ama GORUNUR gonder butonu KALIYOR: klavye
 * ve yardimci teknoloji kullanicilari icin otomatik gonderim tek basina
 * yeterli degil (yapistirma sonrasi odak yerinde kalabiliyor).
 */
export function OtpInput({
  value,
  onChange,
  onComplete,
  label,
  disabled = false,
  invalid = false,
  describedBy,
}: {
  value: string
  onChange(value: string): void
  onComplete?(value: string): void
  label?: string
  disabled?: boolean
  invalid?: boolean
  describedBy?: string
}) {
  const { t } = useTranslation()
  const id = useId()
  // Varsayilan etiket RENDER aninda cevriliyor. Parametre varsayilani
  // olarak yazmak modul seviyesinde degerlendirilir ve dil degistiginde
  // guncellenmezdi.
  const shown = label ?? t('auth.totp.codeLabel')

  return (
    <div className="field">
      <label htmlFor={id}>{shown}</label>
      <input
        id={id}
        className="otp"
        // `text` + `inputMode="numeric"`: `type="number"` artis/azalis oklari
        // ekliyor, kaydirmayla degeri degistiriyor ve bastaki sifiri
        // kirpabiliyor.
        type="text"
        inputMode="numeric"
        autoComplete="one-time-code"
        pattern="\d{6}"
        maxLength={6}
        value={value}
        disabled={disabled}
        aria-invalid={invalid || undefined}
        aria-describedby={describedBy}
        autoFocus
        onChange={(event) => {
          const next = normalizeOtp(event.target.value)
          onChange(next)
          if (isCompleteOtp(next)) onComplete?.(next)
        }}
      />
    </div>
  )
}
